import { render, staticRenderFns } from "./BattleProgress.vue?vue&type=template&id=45f8a1a4&"
import script from "./BattleProgress.vue?vue&type=script&lang=js&"
export * from "./BattleProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports